export default __webpack_public_path__ + "static/home-repair-2b0e2f9cfc9ef92bb1d7a8e74363a2af.jpg";